import { render, staticRenderFns } from "./file-display.vue?vue&type=template&id=dd5c01ce&scoped=true"
import script from "./file-display.vue?vue&type=script&lang=js"
export * from "./file-display.vue?vue&type=script&lang=js"
import style0 from "./file-display.vue?vue&type=style&index=0&id=dd5c01ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd5c01ce",
  null
  
)

export default component.exports